import { apiGet, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const certificatesApi = {
  listMine: (params?: PaginatedParams & { type?: string; search?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.type) searchParams.set("type", params.type);
    if (params?.search) searchParams.set("search", params.search);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/certificates?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/certificates/${id}`),

  bulkRevoke: (ids: string[]) => apiDelete<{ data: number }>(`/certificates/certificates/bulk-revoke`, { data: { ids } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`/certificates/certificates/stats`),

  export: (type?: string, format = "CSV") => apiGet<{ data: unknown }>(`/certificates/certificates/export?type=${type ?? ""}&format=${format}`),
};